<template>
  <LibraryListItem>
    <DocumentScoreLink
      :id="document.id"
      :score="document.score_total_capped"
      :language-code="document.language_code"
      class="ml-5"
    />
    <PostTitleCompanyBadgesCell
      :title="document.title"
      :company="document.company"
      :is-external="document.is_external"
      :is-evergreen="document.is_evergreen"
      :language-code="document.language_code"
    />

    <div
      class="document-date"
      data-testid="revision-modified-date"
    >
      {{ document.revision_modified_at ? new Date(document.revision_modified_at).toLocaleDateString("en-US") : '' }}
    </div>
    <PostReqIdCell
      :req-uuid="document.req_uuid"
      :ats-req-id="document.ats_requisition_id"
      :flexible-id="document.flexible_id"
      @library-req-report-track="emits('library-req-report-track', document)"
    />
    <PostLocationCell :location="document.location" />
    <PostDepartmentCell
      v-if="integrated"
      :ats-department-name="document.ats_department_name"
    />
    <div
      v-if="integrated"
      class="info-section"
    >
      {{ createdInValue }}
    </div>
  </LibraryListItem>
</template>

<script setup>
import { computed } from 'vue';
import LibraryListItem from '@/components/shared/LibraryListItem.vue';
import PostTitleCompanyBadgesCell from '@/components/library/listItemCells/PostTitleCompanyBadgesCell.vue';
import PostReqIdCell from '@/components/library/listItemCells/PostReqIdCell.vue';
import PostLocationCell from '@/components/library/listItemCells/PostLocationCell.vue';
import PostDepartmentCell from '@/components/library/listItemCells/PostDepartmentCell.vue';
import DocumentScoreLink from '@/components/shared/DocumentScoreLink.vue';

const props = defineProps({
  document: {
    type: Object,
    required: true,
  },
  integrated: {
    type: Boolean,
    required: true,
  },
});

const emits = defineEmits(['library-req-report-track']);

const createdInValue = computed(() => {
  if (['taprecruit', 'datapeople'].includes(props?.document?.platform.toLowerCase())) {
    return 'JobNav';
  }
  if (props?.document?.platform?.toLowerCase()?.includes('datapeople anywhere')) {
    return 'JobNav Anywhere';
  }
  return props?.document?.platform || '';
});
</script>

<style lang="less" scoped>
.info-section {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 500;
}
</style>
